const PLUGIN_NAME = 'custonm_price';

import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {useSelector} from 'react-redux';
import {Form, Label} from 'semantic-ui-react';
import {Param} from 'indico/react/i18n';

import {FinalInput, FinalField, validators as v, parsers as p} from 'indico/react/forms';

import {getPriceFormatter} from './selectors.js';
import {getFieldValue, getManagement, getPaid} from './submission_selectors';

import {registerPluginObject} from 'indico/utils/plugins';

import './regform.module.scss';

function CustomPriceInputComponent({title, id, value, onChange}) {
  const formatPrice = useSelector(getPriceFormatter);
  const total = (value+0.0).toFixed(2);

  const paid = useSelector(getPaid);
  const management = useSelector(getManagement);
  const disabled = paid && !management

  return (
        <div styleName="custom_price_field">

    {management && (
        <div styleName="number-field">
            <legend>{ title } (Admin)</legend>
          <input
            id={id}
            type="number"
            value={value !== null ? value : ''}
            disabled={disabled}
            onChange={evt => onChange(evt.target.value ? +evt.target.value : null)}
          />
            <Label pointing="left" styleName="price-tag">
              {formatPrice(-total)}
            </Label>
        </div>
      )}

    {total != 0.0 && (
        <div styleName="custom_price">
          { title }:{' '}
          <Param name="price" value={value !== null ? formatPrice(value) : "-"} />
        </div>
    )}
      </div>
  );
}


CustomPriceInputComponent.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

CustomPriceInputComponent.defaultProps = {
  value: null,
};

export default function CustomPriceInput({
  title,
  htmlId,
  htmlName,
  isRequired
}) {
  const validate = isRequired
    ? v.chain(v.required, v.number())
    : v.chain(v.optional(), v.number());
  return (
    <FinalField
      title={title}
      id={htmlId}
      name={htmlName}
      component={CustomPriceInputComponent}
      required={isRequired}
      allowNull
      parse={p.number}
      validate={validate}
    />
  );
}

CustomPriceInput.propTypes = {
  title: PropTypes.string.isRequired,
  htmlId: PropTypes.string.isRequired,
  htmlName: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
};

CustomPriceInput.defaultProps = {
  isRequired: false,
};


export const customFields = {
    name: "ext__customprice",
    title: "Custom Price",
    inputComponent: CustomPriceInput,
    hasPrice: false,
    icon: 'seven-segment9',
    noLabel: true,
    renderAsFieldset: true,
    customFormItem: true
}

registerPluginObject(PLUGIN_NAME, 'regformCustomFields', customFields);
